import { render, staticRenderFns } from "./ShopCourseDetail.vue?vue&type=template&id=1a2390c2&scoped=true&"
import script from "./ShopCourseDetail.vue?vue&type=script&lang=js&"
export * from "./ShopCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopCourseDetail.vue?vue&type=style&index=0&id=1a2390c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2390c2",
  null
  
)

export default component.exports